import React, { useState, useEffect } from 'react'
import BorderBtn from '../../Common/BorderBtn';
import * as Yup from 'yup';

export default function Customize({sampleSlug}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    
    const fieldsReportCustomization = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'

        },
        {
            name: 'message',
            label: '',
            placeholder: 'Please provide your customization requirements to get report tailored to your needs!',
            type: 'textarea',
            col_row: 2,
            customClass: 'md:col-span-12 col-span-12'
        },
    ];
    return (
        <>
            <div className='my-4 border p-4 rounded-md bg-gray-100 dark:bg-gray-800'>
                <h3 className='text-md font-semibold'>Customize Reports As Per Your Needs</h3>
                <p className='text-sm'>
                    Don&apos;t see what you&apos;re looking for? Get a report tailored to your specific requirements. Customize your report now!
                </p>
                <BorderBtn 
                    customClass="flex justify-center bg-[#1e5df3] w-full mx-auto hover:bg-[#1b5df3] text-white font-semibold py-2 px-6 rounded text-sm"
                    buttonTitle="Request Now"
                    form_name="request-for-customization-form"
                    product_name ={sampleSlug?.name}
                    formTitle="Report Customization"
                    customFields={fieldsReportCustomization}
                    endpoint="/enquiry/report-customization"
                    onclick={openModal}
                    slug={sampleSlug?.slug}
                />
            </div>
        </>
    )
}